(function ($) {
    $(document).ready(function() {
        var countryCode = getCookie('country_code'),
            geoVar = getQueryVariable('location'),
            geoIpDisabled = theme.geoIp,
            geoIpRegion = theme.geoIpRegion,
            popupMessage = theme.geoIpMessage,
            popupButton = theme.geoIpButton,
            apiKey = theme.geoIpApiKey,
            storeURLs = {
                'GB': 'https://sleeping-baby-uk.myshopify.com/?location=GB',
                'US': 'https://www.sleepingbaby.com/?location=US',
            };

        function handleResponse(response) {
            var locationCountryCode = response.country_code2 !== undefined ? response.country_code2 : geoIpRegion;
            if ((geoIpRegion == 'US' && locationCountryCode == 'GB')
                || (geoIpRegion == 'GB' && locationCountryCode != 'GB')) {
                var wrapper = document.createElement('div');
                wrapper.className = 'geoip-wrapper';
                var overlay = document.createElement('div');
                overlay.className = 'geoip-overlay';
                wrapper.appendChild(overlay);
                var popup = document.createElement('div');
                popup.className = 'geoip-popup';
                var closeBtn = document.createElement('a');
                closeBtn.className = 'geoip-close';
                closeBtn.setAttribute('href', '#');
                popup.appendChild(closeBtn);
                $(closeBtn).on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    $(wrapper).hide();
                    setCookie('country_code', geoIpRegion, 1, 0);
                });
                var message = document.createElement('div');
                message.className = 'geoip-message';
                message.innerHTML = popupMessage
                    .replace(/{{country_name}}/g, response.country_name)
                    .replace(/{{country_code}}/g, response.country_code2);
                popup.appendChild(message);
                var button = document.createElement('a');
                button.className = 'geoip-button';
                button.setAttribute('href', '#');
                button.innerHTML = popupButton
                    .replace(/{{country_name}}/g, response.country_name)
                    .replace(/{{country_code}}/g, geoIpRegion != 'US'
                        ? (locationCountryCode == 'US' ? 'USA' : 'international')
                        : (response.country_code2 == 'GB' ? 'UK' : response.country_code2));
                popup.appendChild(button);
                $(button).on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    setCookie('country_code', storeURLs[locationCountryCode] ? locationCountryCode : 'US', 1, 0);
                    window.location.href = storeURLs[locationCountryCode] || storeURLs.US;
                });
                wrapper.appendChild(popup);
                document.body.appendChild(wrapper);
            } else {
                setCookie('country_code', geoIpRegion, 1, 0);
            }
        }

        function setCookie(cname, cvalue, exdays, exhours) {
            var d = new Date();

            if (exdays == 0 && exhours > 0) {
                d.setTime(d.getTime() + (exhours * 60 * 60 * 1000));
            } else {
                d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            }

            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        function getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        function getQueryVariable(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) {
                    return pair[1];
                }
            }
            return (false);
        }

        if (!geoIpDisabled && window.location.href.indexOf("blogs") === -1) {
            if (geoVar && ['US', 'GB'].includes(geoVar)) {
                setCookie('country_code', geoIpRegion, 1, 0);
            } else if (!countryCode) {
                _ipgeolocation.getGeolocation(handleResponse.bind(this), apiKey);
            } else if (countryCode && countryCode != geoIpRegion) {
                window.location.href = storeURLs[countryCode] || storeURLs.US;
            }
        }
    });
})(jQuery);
